export enum ToggleSwitchSize {
  SMALL = 'SMALL',
  DEFAULT = 'DEFAULT',
}

export enum ToggleSwitchStyleVariant {
  DEFAULT = 'default',
  AI = 'ai',
  COMPACT = 'compact',
}
